import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState
} from 'react';
import Section from '~/constants/vdp/section';

type ContextType = {
  sectionsViewed: Partial<Record<Section, boolean>>;
  setSectionViewed: (section: Section) => void;
};

const defaultContext: ContextType = {
  sectionsViewed: {
    [Section.Gallery]: false,
    [Section.RecommendedVehicles]: false
  },
  setSectionViewed: () => {}
};

const UiContext = createContext<ContextType>(defaultContext);

export function UiContextProvider({ children }: React.PropsWithChildren<{}>) {
  const [sectionsViewed, setSectionsViewed] = useState(
    defaultContext.sectionsViewed
  );

  const setSectionViewed = useCallback((section: Section) => {
    setSectionsViewed(prev => ({ ...prev, [section]: true }));
  }, []);

  const value = useMemo(
    () => ({
      sectionsViewed,
      setSectionViewed
    }),
    [sectionsViewed, setSectionViewed]
  );

  return <UiContext.Provider value={value}>{children}</UiContext.Provider>;
}

UiContextProvider.displayName = 'UiContextProvider';

export default UiContext;

export function useSectionViewed(section: Section) {
  return useContext(UiContext).sectionsViewed[section] ?? false;
}
